<template>
  <div class="page-wrapper auth">
    <div class="page-inner bg-brand-gradient">
      <div class="page-content-wrapper bg-transparent m-0">
        <div class="height-10 w-100 shadow-lg px-4 bg-brand-gradient">
          <div class="d-flex align-items-center container p-0">
            <div
              class="page-logo width-mobile-auto m-0 align-items-center justify-content-center p-0 bg-transparent bg-img-none shadow-0 height-9 border-0"
            >
              <a
                href="javascript:void(0)"
                class="page-logo-link press-scale-down d-flex align-items-center"
              >
                <img src="img/logo.png" aria-roledescription="logo" />
                <span class="page-logo-text mr-1" style="color: #073190"
                  >業務管理システム</span
                >
              </a>
            </div>
          </div>
        </div>
        <div
          class="flex-1"
          style="
            background: url(img/svg/pattern-1.svg) no-repeat center bottom fixed;
            background-size: cover;
          "
        >
          <div class="container py-4 py-lg-5 my-lg-5 px-4 px-sm-0">
            <div class="row">
              <div class="col col-md-6 col-lg-7 hidden-sm-down">
                <img
                  src="img/mainlogo.png"
                  alt="メインロゴ"
                  style="width: 90%"
                />
              </div>
              <div class="col-sm-12 col-md-6 col-lg-5 col-xl-4 ml-auto">
                <div class="card p-4 rounded-plus bg-faded">
                  <div
                    class="loader"
                    id="loaderLgin"
                    style="text-align: center"
                  >
                    <i
                      style="margin-top: 90px"
                      class="fal fa-spinner-third fa-spin-4x fs-xxl"
                    ></i>
                  </div>
                  <div class="form-group">
                    <label class="form-label" for="username">ログインID</label>
                    <input
                      type="text"
                      id="username"
                      class="form-control form-control-lg"
                      placeholder="ログインID"
                      v-model="loginid"
                      required
                    />
                  </div>
                  <div class="form-group">
                    <label class="form-label" for="password">パスワード</label>
                    <input
                      type="password"
                      id="password"
                      class="form-control form-control-lg"
                      placeholder="password"
                      v-model="loginpass"
                      required
                    />
                  </div>
                  <div class="spacer-login"></div>
                  <div class="row no-gutters">
                    <div class="col-lg-12 pr-lg-1 my-2">
                      <button
                        type="submit"
                        class="btn btn-info btn-block btn-lg"
                        @click="login()"
                      >
                        ログイン
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="position-absolute pos-bottom pos-left pos-right p-3 text-center text-white"
            >
              <i><strong>System Message:ver 20261006042948</strong> </i>
              &nbsp;&nbsp;&nbsp;2026 &nbsp;<a
                href="https://fusion-outdoor.co.jp/"
                class="text-white opacity-40 fw-500"
                title="https://fusion-outdoor.co.jp/"
                target="_blank"
                >https://fusion-outdoor.co.jp/</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- モーダル -->
  <Mo_modal_alert ref="Mo_modal">
    <template v-slot:title>
      <i class="fal fa-times-circle text-danger mr-2"></i>{{ message4Modal }}
    </template>
    <template v-slot:body><br /></template>
    <template v-slot:footer>
      <div class="modal-footer">
        <button
          @click="closeModal()"
          type="button"
          class="btn btn-default bootbox-cancel"
        >
          閉じる
        </button>
      </div>
    </template>
  </Mo_modal_alert>
  <!-- モーダル -->
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { Cl_staffImple } from "../functions/Cl_staffImple";
import Mo_modal_alert from "@/components/molecules/Mo_modal_alert.vue";
import Vuex from "vuex";

// import { Cl_client } from "@/functions/Cl_client";
// import { DtoClientsGetReqImple } from "mediadept-common/src/common/dto/DtoClientsGetReqImple";
@Options({
  components: {
    Mo_modal_alert,
  },
})
export default class Login extends Vue {
  //----------------------
  //DOM連携用プロパティ
  //----------------------
  btnDisable = false;
  loginid = "";
  loginpass = "";
  //----------------------
  //セレクトボックス用プロパティ
  //----------------------
  //----------------------
  //モーダル用プロパティ
  //----------------------
  message4Modal = "";

  //----------------------
  //制御用メソッド
  //----------------------
  async mounted() {
    //
  }
  //----------------------
  //基本操作用メソッド
  //----------------------
  async login() {
    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementById("loaderLgin");
    panel?.classList.add("enable-loaderLgin");

    try {
      //空白
      if (this.loginid == "" || this.loginpass == "") {
        this.message4Modal = "IDとパスワードを入力してください";
        //モーダル表示
        const modal: any = this.$refs.Mo_modal;
        modal.showModal();
        return;
      }

      //ログイン
      await Cl_staffImple.signIn(this.loginid, this.loginpass, this.$store);

      //画面遷移
      //-----------------
      this.$router.push("/dashboard");
    } catch (e) {
      this.message4Modal = "IDもしくはパスワードが間違っています";
      //モーダル表示
      const modal: any = this.$refs.Mo_modal;
      modal.showModal();
      return;
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------
      this.btnDisable = false;
      panel?.classList.remove("enable-loaderLgin");
    }
  }
  //----------------------
  //モーダル用メソッド
  //----------------------
  async closeModal(): Promise<void> {
    const modal: any = this.$refs.Mo_modal;
    modal.closeModal();
  }
}
</script>

<style scoped>
.blankpage-form-field {
  width: 320px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.35);
  z-index: 99;
}
.loginbg {
  height: 100vh;
  width: 100%;
  overflow: hidden;
}
.login-footer {
  position: absolute;
}
.page-logo img {
  height: auto;
  width: 70px;
}
.enable-loaderLgin {
  display: block;
}
.spacer-login {
  height: 30px;
}
</style>
